import React from 'react';
import { Card, CardContent } from '../ui/card';
import { TrendingUp, TrendingDown, DollarSign, AlertCircle } from 'lucide-react';

const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(amount || 0);

export const SummaryCards = ({ totals }) => (
  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
    <Card className="shadow-soft border-border/40" data-testid="income-card">
      <CardContent className="p-4 flex items-center gap-4">
        <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center">
          <TrendingUp className="w-5 h-5 text-emerald-600" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Income</p>
          <p className="text-xl font-bold mono text-emerald-600">{formatCurrency(totals.income)}</p>
        </div>
      </CardContent>
    </Card>

    <Card className="shadow-soft border-border/40" data-testid="expenses-card">
      <CardContent className="p-4 flex items-center gap-4">
        <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center">
          <TrendingDown className="w-5 h-5 text-red-600" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Expenses</p>
          <p className="text-xl font-bold mono text-red-600">{formatCurrency(totals.expenses)}</p>
        </div>
      </CardContent>
    </Card>

    <Card className="shadow-soft border-border/40" data-testid="net-card">
      <CardContent className="p-4 flex items-center gap-4">
        <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
          <DollarSign className="w-5 h-5 text-blue-600" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Net Income</p>
          <p className="text-xl font-bold mono">{formatCurrency(totals.income - totals.expenses)}</p>
        </div>
      </CardContent>
    </Card>

    <Card className="shadow-soft border-border/40" data-testid="drafts-card">
      <CardContent className="p-4 flex items-center gap-4">
        <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center">
          <AlertCircle className="w-5 h-5 text-orange-600" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Drafts</p>
          <p className="text-xl font-bold mono">{totals.drafts}</p>
        </div>
      </CardContent>
    </Card>
  </div>
);
